import { FontAwesome5 } from '@expo/vector-icons';
import styled from 'styled-components/native';

export default styled(FontAwesome5).attrs({ name: 'arrow-left', size: 10 })`
  color: #0537ff;
  margin-top: -2px;
`;
